'use strict';

/**
 * JS utils needed all over the place
 *
 * @type {{stateSelect: waUtils.stateSelect, initFloatLabels: waUtils.initFloatLabels, initValidations: waUtils.initValidations, noWrapArrows: waUtils.noWrapArrows, noWrapArrowLink: waUtils.noWrapArrowLink, initCkEditor: waUtils.initCkEditor, postalCodeVsZipCode: waUtils.postalCodeVsZipCode, textRemaining: waUtils.textRemaining, initFancyBox: waUtils.initFancyBox}}
 */
const waUtils = {

	/**
	 * Hides an element if the current date is greater than the given date
	 *
	 * Just call this somewhere inline:
	 * waUtils.hideElementIfDateGreaterThan('element-id', '2020-01-01');
	 *
	 * This method is thought to be used in our dynamic pages but can be used
	 * in other places as well that require some simple date based toggle.
	 *
	 * @link https://github.com/World-Architects/WA3/issues/2962
	 * @param {string} elementId Element ID
	 * @param {string} date Date
	 */
	hideElementIfDateGreaterThan(elementId, date) {
		let now = new Date();
		let endDate = new Date(date);

		if (now < endDate) {
			return;
		}

		let element = document.getElementById(elementId);
		if (element !== null) {
			element.style.visibility = 'hidden';
		}
	},

	/**
	 * Adds the http prefix to a string
	 *
	 * @param {string} url URL
	 * @return string
	 */
	addHttpPrefix: function(url) {
		if (!/^https?:\/\//i.test(url)) {
			url = 'http://' + url;
		}

		return url;
	},

	inputLanguageToggle: function() {
		$('.language-tabs').on('click', 'a', function(e) {
			e.preventDefault();
			let languageId = $(this).data('language-id');

			let textInput = 'div.form-group:has(input[type=text][data-language-id])';
			let textInputId = 'div.form-group:has(input[type=text][data-language-id="' + languageId + '"])';

			let textArea = 'div.form-group:has(textarea[data-language-id])';
			let textAreaId = 'div.form-group:has(textarea[data-language-id="' + languageId + '"])';

			$('.language-tabs a').removeClass('active');
			$(this).addClass('active');

			$(textInput).hide();
			$(textInputId).show();
			$(textArea).hide();
			$(textAreaId).show();
		});

		let languageId = $('.language-tabs a.active').data('language-id');
		$('.language-tabs a[data-language-id="' + languageId + '"]').trigger('click');
	},
	/**
	 * @link https://github.com/World-Architects/WA3/issues/305
	 * @param {string} selector1
	 * @param {string} selector2
	 */
	passwordMatchValidtion: function(selector1, selector2) {
		let password1 = $(selector1);
		let password2 = $(selector2);

		let password1val = password1.val();
		let password2val = password2.val();

		let removeError = function() {
			password1.removeClass('has-error');
			password2.removeClass('has-error');

			password1.next('div.help-block').remove();
			password2.next('div.help-block').remove();

			let helpBlock = password2.next('div.help-block');
			if (helpBlock.length > 0) {
				password1.closest('.form-group').removeClass('has-error');
				password2.closest('.form-group').removeClass('has-error');
			}
		}

		let addError = function() {
			password1.addClass('has-error');
			password2.addClass('has-error');

			password1.closest('.form-group').addClass('has-error');
			password2.closest('.form-group').addClass('has-error');

			let errorMessage = i18next.t('common.the_passwords_dont_match');
			let helpBlock = password2.next('div.help-block');
			if (helpBlock.length !== 1) {
				$('<div class="help-block">' + errorMessage + '</div>').insertAfter(password1);
				$('<div class="help-block">' + errorMessage + '</div>').insertAfter(password2);
			}
		}

		if ((password1.val().length === 0) || (password2.val().length === 0)) {
			removeError();
		} else if (password1val !== password2val) {
			addError();
		} else {
			removeError();
		}
	},
	tagSelect: function(selector, locale) {
		if (locale === undefined) {
			locale = 'en';
		}

		$(selector).select2({
			tags: true,
			minimumInputLength: 3,
			maximumInputLength: 50,
			ajax: {
				url: '/' + locale + '/tags/index.json',
				cache: false,
				data: function (params) {
					return {
						name: params.term
					};
				},
				dataType: 'json',
				processResults: function (data, params) {
					let results = [];

					for (let property in data.tags) {
						results.push({
							text: data.tags[property].name,
							id: data.tags[property].name
						});
					}

					return {results: results};
				}
			},
			createTag: function (params) {
				if (params.term === undefined || params.term.length < 3) {
					return null;
				}

				$.post("/en/tags/add", {name: params.term}, null, 'json')
					.done(function (data) {
						return {
							id: data.tag.name,
							text: data.tag.name
						};
					});

				return {
					id: params.term,
					text: params.term
				};
			}
		}).trigger('change');
	},
	/**
	 * Populate states select fields based on country select
	 *
	 * The state input field MUST have a data-state-id field!
	 *
	 * @param {string} countrySelector
	 * @param {string} stateSelector
	 */
	stateSelect: function(countrySelector, stateSelector) {
		let stateSelect = $(stateSelector);
		let countrySelect = $(countrySelector);
		let stateId = $(stateSelector).data('state-id');

		if (stateId === undefined) {
			throw 'stateSelect() requires the data-state-id attribute on `' + stateSelector + '`!';
		}

		let getStates = function(countryId) {
			stateSelect.attr('disabled', true);

			let language = 'en';
			if (typeof waApp !== 'undefined') {
				let language = waApp.getLanguage();
			}

			$.getJSON('/' + language + '/country-states/index.json?country_id=' + countryId, function(result) {
				stateSelect.append($('<option />').val('').text('State'));
				$.each(result.countryStates, function() {
					stateSelect.append($('<option />').val(this.id).text(this.name));
				});
				stateSelect.val(stateId);
				stateSelect.attr('disabled', false);
			});
		};

		// Update the states when the country is changing
		countrySelect.change(function(e) {
			e.preventDefault();
			let countryId = $(this).val();
			stateSelect.html('');
			// http://stackoverflow.com/questions/19639951/how-do-i-change-selected-value-of-select2-dropdown-with-jqgrid
			stateSelect.val('').change();
			if (countryId !== undefined && countryId.length > 0) {
				stateSelect.attr('disabled', true);
				getStates(countryId);
			} else {
				stateSelect.attr('disabled', true);
			}
		});

		$(countrySelector).trigger('change');
	},
	/**
	 * Init the FloatLabels lib
	 *
	 * @see Lib/floating-label.js
	 */
	initFloatLabels: function() {
		// Init floating labels, see Libs/floatin-label.js
		$('.form-group').addClass('float-label-control');

		// Remove Floating label from specific class here
		$('.navbar-search').removeClass('float-label-control');
		$('.radio').removeClass('float-label-control');

		// Needs to be called after class is set
		$('.float-label-control').floatLabels();
	},
	/**
	 * Configure the jquery-validation plugin to work with Bootstrap 3
	 * @link https://jqueryvalidation.org/
	 * @link http://stackoverflow.com/questions/18754020/bootstrap-3-with-jquery-validation-plugin
	 */
	initValidations: function() {
		$.validator.setDefaults({
			errorElement: 'span',
			errorClass: 'help-block',
			highlight: function(element, errorClass, validClass) {
				$(element).closest('.form-group').addClass('has-error');
			},
			unhighlight: function(element, errorClass, validClass) {
				$(element).closest('.form-group').removeClass('has-error');
			},
			errorPlacement: function(error, element) {
				let propType = element.prop('type');
				if (element.parent('.input-group').length || propType === 'checkbox' || propType === 'radio') {
					error.insertAfter(element.parent());
				} else {
					error.insertAfter(element);
				}
			}
		});
	},
	/**
	 * Replaces the markup and attaches wa-arrow for .no-wrap-arrow h2
	 */
	noWrapArrows: function() {
		$('.no-wrap-arrow h2').each(function() {
			let $this = $(this);
			let text = $this.text().trim();
			let words = text.split(/\s+/);
			let lastWord = words.pop();

			words.push('<div class="no-wrap">' + lastWord + ' <i class="wa-arrow wa-arrow-large"></i></div>');
			$this.html(words.join(' '));
		});
	},
	/**
	 * Replaces the markup and attaches wa-arrow for specified selector
	 *
	 * @param {string} selector
	 * @param {string} arrowSize (Values: wa-arrow-small, wa-arrow-medium, wa-arrow-large, wa-arrow-x-large) Default: wa-arrow-large
	 */
	noWrapArrowLink: function(selector, arrowSize = 'wa-arrow-large') {
		$(selector).each(function() {
			let $this = $(this);
			let text = $this.text().trim();
			let words = text.split(/\s+/);
			let lastWord = words.pop();

			words.push('<div class="no-wrap">' + lastWord + ' <i class="wa-arrow ' + arrowSize + '"></i></div>');

			$(this).find('a').html(words.join(' '));
		});
	},
	/**
	 * Init CKEDITOR with specified config
	 *
	 * @param {array} config
	 */
	initCkEditor: function(config) {
		if (CKEDITOR === undefined) {
			throw 'CKEDITOR variable is not present or accessible!';
		}
		$('textarea.ckeditor').each(function() {
			CKEDITOR.replace($(this).attr('id'), config);
		});
	},
	initFancyBox: function() {
		$.fancybox.defaults.hash = 'image';
	},
	/**
	 * Replaces the input placeholder for countryId 11
	 *
	 * @param {string} countriesIdSelector
	 * @param {string} postalCodeSelector
	 */
	postalCodeVsZipCode: function(countriesIdSelector, postalCodeSelector) {
		let originalPlaceholder = $(postalCodeSelector).attr('placeholder');
		$(countriesIdSelector).change(function(e) {
			e.preventDefault();
			let countryId = $(this).val();

			if (countryId == 11) {
				$(postalCodeSelector).attr('placeholder', 'Zip Code');
			} else {
				$(postalCodeSelector).attr('placeholder', originalPlaceholder);
			}
		});
	},
	/**
	 * Shows how much text chars are remaining until maxLength is reached
	 *
	 * @param {string} input Selector
	 * @param {string} counterOutput Selector
	 * @param {integer} maxLength
	 */
	textRemaining: function(input, counterOutput, maxLength) {
		if (maxLength === undefined) {
			maxLength = 100;
		}

		$(counterOutput).html(maxLength);

		$(input).on('keyup', function() {
			let textLength = $(input).val().length;
			let textRemaining = maxLength - textLength;

			if (textLength > maxLength) {
				textRemaining = 0;
				$(this).val($(this).val().substring(0, maxLength));
			}

			$(counterOutput).html(textRemaining);
		});
	},
	/**
	 * Display or hide element by country iso3 list
	 *
	 * This function depends on exposing window.countryIso3 var true the view
	 *
	 * Examples:
	 * waUtils.showElementByIsoCode('asia-edition', ["CHN", "KOR", "IND", "JPN"] , 'show');
	 * waUtils.showElementByIsoCode('europe-edition', ["CHN", "KOR", "IND", "JPN"] , 'hide');
	 *
	 * @param elementId
	 * @param iso3
	 * @param display values: show or hide
	 */
	showElementByIsoCode: function (elementId, iso3, display) {
		if (typeof(window.countryIso3) !== 'undefined') {

			let showElement = true;
			let element = document.getElementById(elementId);

			if (element !== null) {
				if (iso3.includes(window.countryIso3) && display === 'hide') {
					showElement = false;
				}

				if (!iso3.includes(window.countryIso3) && display === 'show') {
					showElement = false;
				}


				if (!showElement) {
					element.parentNode.removeChild(element);
				}
			}




		} else {
			if (waApp.debug === true) {
				console.log('countryIso is not defined');
			}
		}
	}

};

window.waUtils = waUtils;
